module.exports = __webpack_public_path__ + "static/media/eshterahVideo.6b90b9ee.svg";